import { useState, useRef } from "react";
import { uploadDocuments } from "../api";
import "./UploadModal.css";

export default function UploadModal({ onClose, onSuccess }) {
  const [files, setFiles] = useState([]);
  const [subject, setSubject] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const ACCEPTED_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/tiff",
  ];

  function addFiles(newFiles) {
    const valid = Array.from(newFiles).filter((f) =>
      ACCEPTED_TYPES.includes(f.type)
    );
    if (valid.length < newFiles.length) {
      setError("მხოლოდ PDF და სურათები (JPEG, PNG, TIFF) დაშვებულია.");
    }
    setFiles((prev) => [...prev, ...valid]);
  }

  function handleDrop(e) {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files.length) {
      addFiles(e.dataTransfer.files);
    }
  }

  function handleRemoveFile(index) {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  }

  function formatSize(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }

  async function handleUpload() {
    if (!files.length) return;
    setLoading(true);
    setError(null);
    try {
      const result = await uploadDocuments(files, subject);
      onSuccess(result);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  }

  return (
    <div className="upload-overlay" onClick={onClose}>
      <div className="upload-box" onClick={(e) => e.stopPropagation()}>
        <h2 className="upload-title">დოკუმენტის ატვირთვა</h2>

        <div
          className={`upload-dropzone ${dragOver ? "drag-over" : ""}`}
          onDragOver={(e) => {
            e.preventDefault();
            setDragOver(true);
          }}
          onDragLeave={() => setDragOver(false)}
          onDrop={handleDrop}
          onClick={() => fileInputRef.current?.click()}
        >
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#016394" strokeWidth="1.5">
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          <p>ჩააგდეთ ფაილები აქ ან დააჭირეთ ასარჩევად</p>
          <span className="upload-hint">PDF, JPEG, PNG, TIFF</span>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept="application/pdf,image/jpeg,image/png,image/tiff"
            style={{ display: "none" }}
            onChange={(e) => {
              addFiles(e.target.files);
              e.target.value = "";
            }}
          />
        </div>

        {files.length > 0 && (
          <div className="upload-file-list">
            {files.map((file, i) => (
              <div key={i} className="upload-file-item">
                <span className="upload-file-name">{file.name}</span>
                <span className="upload-file-size">{formatSize(file.size)}</span>
                <button
                  className="upload-file-remove"
                  onClick={() => handleRemoveFile(i)}
                  title="წაშლა"
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        )}

        <input
          type="text"
          className="upload-subject"
          placeholder="სათაური / აღწერა (არასავალდებულო)"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />

        {error && <div className="upload-error">{error}</div>}

        <div className="upload-footer">
          <button className="resp-btn cancel" onClick={onClose} disabled={loading}>
            გაუქმება
          </button>
          <button
            className="resp-btn approve"
            onClick={handleUpload}
            disabled={loading || !files.length}
          >
            {loading ? "მიმდინარეობს..." : "ატვირთვა"}
          </button>
        </div>
      </div>
    </div>
  );
}
